export default "__VITE_ASSET__d7e39ad7__"